<template lang="pug">
.mt-3.container
  .card
    .card-header.font-weight-bold
      | {{ $t("components.restore_password_request.tpl.card_header") }}
      small.d-block {{ $t("components.restore_password_request.tpl.card_text") }}

    .card-body.my-2
      label.m-0.mr-3(for="user-or-email") {{ $t("components.restore_password_request.tpl.label") }}
      a-input#user-or-email.mr-5(
        v-model="inputData"
        :disabled="success"
        @keypress.enter="handleSend"
      )
      button.mr-2.py-1.px-2.btn.btn-primary(
        :disabled="!inputData || success"
        type="button",
        @click="handleSend"
      ) {{ $t("components.restore_password_request.tpl.send_button") }}
      button.py-1.px-2.btn.btn-outline-primary(
        type="button"
        @click="handleGoToRedirectUrl"
      ) {{ $t("components.restore_password_request.tpl.redirect_button") }}

    a-alert.mx-4.mb-4(
      v-if="userNotFound"
      :message="$t('components.restore_password_request.tpl.alert_message')"
      :description="$t('components.restore_password_request.tpl.alert_user_not_found_message')"
      type="warning"
    )

    a-alert.mx-4.mb-4(
      v-if="error"
      :message="$t('components.restore_password_request.tpl.alert_message')"
      :description="$t('components.restore_password_request.tpl.alert_error_message')"
      type="error"
    )

    a-alert.mx-4.mb-4.w-full(
      v-if="success"
      :message="$t('components.restore_password_request.tpl.alert_message')"
      :description="$t('components.restore_password_request.tpl.alert_success_message')"
      type="success"
    )
</template>

<script>
import { template } from 'lodash';
import i18n from '@/i18n';
import { fetchUserWithRefererAuth, fetchRestorePasswordLink, sendMailViaScuApi } from '@/api';

export default {
  props: {
    instance: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: null,
    },
    autoLogin: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      inputData: '',
      error: false,
      success: false,
      userNotFound: false,
    };
  },
  methods: {
    async handleSend() {
      this.error = false;

      try {
        const referer = window.location.href.split('?')[0];

        const userFilter = {
          instance: this.instance,
          referer,
        };

        if (this.inputData.includes('@')) {
          userFilter.mail = this.inputData;
        } else {
          userFilter.username = this.inputData;
        }

        const user = await fetchUserWithRefererAuth(userFilter);

        if (!user) {
          this.userNotFound = true;
          return;
        }

        const link = await fetchRestorePasswordLink({
          userId: user.id,
          userName: user.name,
          userMail: user.mail,
          userUsername: user.username,
          instance: this.instance,
          redirectUrl: btoa(this.redirectUrl),
          locale: i18n.locale,
          autoLogin: this.autoLogin,
        });

        await sendMailViaScuApi({
          user,
          subject: this.$t('components.restore_password_request.mail.subject'),
          text: template(this.$t('components.restore_password_request.mail.text'))({
            userName: user.name,
            userUsername: user.username,
            lostPasswordLink: link,
          }),
          to: [user.mail],
          referer,
        });

        this.success = true;
      } catch (error) {
        this.error = true;
        console.log(error);
      }
    },
    handleGoToRedirectUrl() {
      window.location = decodeURIComponent(this.redirectUrl);
    },
  },
};
</script>

<style scoped>
.card-body {
  display: block;
}
#user-or-email {
  width: 100%;
  margin-bottom: 20px;
}
@media (min-width: 996px) {
  .card-body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #user-or-email {
    width: 60%;
    margin-bottom: 0px;
  }
}
</style>
